import {
  AutoConf,
  ImportLinksResult,
  ImportParseResult,
  ResultList,
  Search,
  SearchPost,
} from "core/types/search.types";
import { ApiFactoryClients } from "../api.types";
import {
  transformAutoConf,
  transformImportLinks,
  transformImportParse,
  transformResults,
  transformSearch,
} from "./search.helpers";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  // Il backend ora risponde {message, id} (SFM): transformSearch espone l'id
  // (e results: [] come fallback) cosi' il chiamante puo' avviare il polling.
  newSearch: (newSearchPayload: SearchPost): Promise<Search> =>
    codeHttpClient
      .post("/searches", {
        search_type: newSearchPayload.searchType,
        sort: newSearchPayload.sortedBy,
        country: newSearchPayload.country,
        language: newSearchPayload.language,
        full_name: newSearchPayload.fullName,
        params: newSearchPayload.params,
        // Modalita' Social (additiva): inoltrati solo se valorizzati da searchType==='social'
        platforms: newSearchPayload.platforms,
        include_comments: newSearchPayload.include_comments,
      })
      .then(({ data }) => transformSearch(data)),
  getList: (): Promise<ResultList[]> =>
    codeHttpClient.get("/searches").then(({ data }) => transformResults(data)),
  getSearchDetail: (id: string): Promise<Search> =>
    codeHttpClient
      .get(`/searches?search_id=${id}`)
      .then(({ data }) => transformSearch(data)),
  getAutoSearchList: (): Promise<AutoConf> =>
    codeHttpClient
      .get("/searches/auto/config")
      .then(({ data }) => transformAutoConf(data)),
  newNameAutoSearch: (name: string): any =>
    codeHttpClient
      .post("/searches/auto/config/name", { name: name })
      .then(({ data }) => data),
  editNameAutoSearch: (id: string, newName: string): any =>
    codeHttpClient
      .put(`/searches/auto/config/name?id=${id}`, { new_name: newName })
      .then(({ data }) => data),
  newParamsAutoSearch: (param: string): any =>
    codeHttpClient
      .post("/searches/auto/config/params", { param: param })
      .then(({ data }) => data),
  deleteParamsAutoSearch: (id: string): any =>
    codeHttpClient
      .delete(`/searches/auto/config/params?id=${id}`)
      .then(({ data }) => data),
  addManual: (title: string, url: string, searchId: string) =>
    codeHttpClient
      .put(`/searches?search_id=${searchId}`, {
        url: url,
        // description: "",
        // thumbnail_url: "",
        title: title,
        // search_id: searchId,
      })
      .then((data) => data),
  // Import da Excel/CSV, passo 1: il file viene letto dal backend e torna come anteprima
  // (nessuna scrittura). Multipart: axios imposta da solo il boundary con FormData.
  parseImportLinks: (searchId: string, file: File): Promise<ImportParseResult> => {
    const formData = new FormData();
    formData.append("file", file);
    return codeHttpClient
      .post(
        `/searches/import/parse?search_id=${encodeURIComponent(searchId)}`,
        formData
      )
      .then(({ data }) => transformImportParse(data));
  },
  // Passo 2: un lotto di link (max 25 per chiamata) viene aggiunto alla ricerca.
  importLinks: (
    searchId: string,
    items: { url: string; note?: string }[]
  ): Promise<ImportLinksResult> =>
    codeHttpClient
      .post(`/searches/import?search_id=${encodeURIComponent(searchId)}`, {
        items,
      })
      .then(({ data }) => transformImportLinks(data)),
});
